export default __webpack_public_path__ + "static/media/KOL-OLLA RAMLAN.36786b2c.jpg";